export const styles = {
  networkingButtons: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
  },
  requestContactIfo: {
    marginLeft: "15px",
    cursor: "pointer",
    color: "text.tertiary",
  },
};
